<div class="ds-search-input" [ngClass]="{'not-empty': value}" [ngStyle]="{width: width}">
  <i class="db-icon db-icon-search" *ngIf="hasSearchIcon"></i>
  <i class="db-icon db-icon-close" *ngIf="value?.length && !showLoading" (click)="clearValue()"></i>
  <div class="spinner">
    <db-loading-circular-spinner
                                 *ngIf="showLoading"
                                 size="sm"
                                 [newMode]="true">
    </db-loading-circular-spinner>
  </div>
  <input type="text" class="ds-input"
         name="searchInput"
         [placeholder]="placeholder"
         (input)="onChange.next($event)"
         (keydown)="onKeydown($event)"
         [ngModel]="value"
         (ngModelChange)="modelChange($event)"
         autocomplete="off">
</div>
